import { render, staticRenderFns } from "./tickes-list.vue?vue&type=template&id=09cebec6&scoped=true&"
import script from "./tickes-list.vue?vue&type=script&lang=js&"
export * from "./tickes-list.vue?vue&type=script&lang=js&"
import style0 from "./tickes-list.vue?vue&type=style&index=0&id=09cebec6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cebec6",
  null
  
)

export default component.exports